import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-connect-membership',
  templateUrl: `${environment.pageFolder}/connect-membership.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/connect-membership.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, NgxMaskDirective, TranslateModule]
})
export class ConnectMembershipComponent {
  loader = document.getElementById("loader-container");
  @Output() onSubmitConnectMembership = new EventEmitter<any>();
  @Input() errorMessageMyMembership: string = "";
  @Input() infoMessage: string = "";
  @Input() myMembership!: boolean;
  @Input() connectMembershipForm!: any;
  @Input() isClubFriend!: boolean;

  constructor() {}

  removeErrorMessage() {
    this.errorMessageMyMembership = "";
  }
}
